export default __webpack_public_path__ + "static/media/Screenshot (151).6040fa34.png";